const POLLING_TIMEOUT = 5000;

const performRequest = async requestMethod => {
  let response;
  let error;
  try {
    response = await requestMethod();
  } catch (e) {
    error = e;
  }
  return { response, error };
};

const pollingHelper = async ({
  requestMethod,
  exitCondition,
  pollingTimeout = POLLING_TIMEOUT,
  maxAttempts = Number.MAX_SAFE_INTEGER,
  breakOnError = false,
}) => {
  let attempts = 0;

  /* eslint-disable */
  const executePoll = async (resolve, reject) => {
    const { response, error } = await performRequest(requestMethod);
    attempts++;
    if (exitCondition(response)) {
      return resolve(response);
    } else if (error && breakOnError) {
      reject(error);
    } else if (attempts === maxAttempts) {
      return reject(new Error(`Exceeded max attempts`));
    } else {
      setTimeout(executePoll, pollingTimeout, resolve, reject);
    }
  };

  return new Promise(executePoll);
};

export default pollingHelper;
